module.exports = __webpack_public_path__ + "img/scholar.77a5b76c.png";